import { ProductOrBrand } from "./alternativeTypes";

export const streamingProducts: ProductOrBrand[] = [
  {
    name: "Netflix",
    ownerCountry: "US",
    categories: ["streaming", "tv-and-movies"],
  },
  {
    name: "Disney+",
    ownerCountry: "US",
    categories: ["streaming", "tv-and-movies"],
  },
  {
    name: "Prime Video",
    ownerCountry: "US",
    categories: ["streaming", "tv-and-movies"],
  },
  {
    name: "Max",
    ownerCountry: "US",
    categories: ["streaming", "tv-and-movies"],
  },
  {
    name: "Discovery+",
    ownerCountry: "US",
    categories: ["streaming", "tv-and-movies"],
  },

  {
    name: "BFI Player",
    ownerCountry: "UK",
    headquarterIn: "UK",
    availableIn: ["UK"],
    comments: "Streaming service by the British Film Institute offering a selection of British, independent, and world cinema.",
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: ["https://en.wikipedia.org/wiki/British_Film_Institute"]
  },
  {
    name: "National Theatre Live",
    ownerCountry: "UK",
    headquarterIn: "UK",
    include: false, // Interesting but niche, right?
    availableIn: ["UK", "FR", "DE", "IT", "ES", "NL", "SE", "NO", "DK", "FI", "IE"],
    comments: "An initiative by the Royal National Theatre in London that broadcasts live performances to cinemas worldwide.",
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: ["https://en.wikipedia.org/wiki/National_Theatre_Live", "https://www.ntlive.com/"]
  },
  {
    name: "Channel 4",
    ownerCountry: "UK",
    headquarterIn: "UK",
    availableIn: ["UK"],
    comments: "British free-to-air public broadcast television channel known for diverse and innovative programming.",
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Channel_4"]
  },
  {
    name: "ITVX",
    ownerCountry: "UK",
    headquarterIn: "UK",
    availableIn: ["UK"],
    comments: "British streaming service launched by ITV plc on 8 December 2022, offering exclusive new shows, blockbuster films, live events, and thousands of boxsets.",
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: ["https://en.wikipedia.org/wiki/ITVX", "https://www.itv.com/"]
  },
  {
    name: "BBC iPlayer",
    ownerCountry: "UK",
    headquarterIn: "UK",
    availableIn: ["UK"],
    comments: "The BBC's streaming service offering live and on-demand access to BBC television and radio programmes.",
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: ["https://en.wikipedia.org/wiki/BBC_iPlayer"]
  },
  {
    name: "ARD Mediathek",
    ownerCountry: "DE",
    headquarterIn: "DE",
    availableIn: ["DE"],
    comments: "The ARD Mediathek is the online streaming platform of the ARD, Germany's consortium of public broadcasters, offering a wide range of TV shows, series, documentaries, and live streams.",
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: ["https://www.ardmediathek.de/", "https://de.wikipedia.org/wiki/ARD_Mediathek"]
  },
  {
    name: "ZDF Mediathek",
    ownerCountry: "DE",
    headquarterIn: "DE",
    availableIn: ["DE"],
    comments: "Online streaming platform of the German public-service television broadcaster ZDF, offering a wide range of TV shows, series, documentaries, and live streams.",
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: ["https://www.zdf.de/", "https://de.wikipedia.org/wiki/ZDFmediathek"]
  },
  {
    name: "3sat Mediathek",
    ownerCountry: "DE",
    headquarterIn: "DE",
    availableIn: ["DE", "AT", "CH"],
    comments: "Online streaming platform of 3sat, a public, advertising-free, German-language television channel with a cultural focus, offering a wide range of programs including documentaries, cultural events, and discussions.",
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: ["https://www.3sat.de/", "https://de.wikipedia.org/wiki/3sat"]
  },
  {
    name: "Viaplay",
    description: "Stream movies, TV-series, childrens' favourites, sports and more.",
    comments: "Not available in all the countries that wikipedia claims. The .com site allows you to select working regions",
    ownerCountry: "SE",
    categories: ["streaming", "tv-and-movies"],
    availableIn: [
      "DK", "FI", "NO", "SE", "IS", "PL", "NL"
    ],
    sourceLinks: [
      "https://sv.wikipedia.org/wiki/Viaplay",
      "https://viaplay.com/gb-en/"
    ],
  },
  {
    name: "TV 2 Play",
    ownerCountry: "DK",
    categories: ["streaming", "tv-and-movies"],
    availableIn: ["DK", "NO"],
    sourceLinks: ["https://play.tv2.dk"],
  },
  {
    name: "DRTV",
    ownerCountry: "DK",
    categories: ["streaming", "tv-and-movies"],
    availableIn: ["DK"],
  },
  {
    name: "MTV",
    ownerCountry: "FI",
    categories: ["streaming", "tv-and-movies"],
    availableIn: ["FI"],
    sourceLinks: ["https://www.mtv.fi"],
  },
  {
    name: "Yle Areena",
    ownerCountry: "FI",
    categories: ["streaming", "tv-and-movies"],
    availableIn: ["FI"],
    sourceLinks: ["https://areena.yle.fi/tv"],
  },
  {
    name: "NRK",
    ownerCountry: "NO",
    categories: ["streaming", "tv-and-movies"],
    availableIn: ["NO"],
    sourceLinks: ["https://tv.nrk.no"],
  },
  {
    name: "SVT Play",
    ownerCountry: "SE",
    categories: ["streaming", "tv-and-movies"],
    availableIn: ["SE"],
    sourceLinks: ["https://www.svtplay.se/"],
  },
  {
    name: "TV4 Play",
    ownerCountry: "SE",
    categories: ["streaming", "tv-and-movies"],
    availableIn: ["SE"],
    sourceLinks: ["https://www.tv4play.se/"],
  },
  {
    name: "RUV",
    ownerCountry: "IS",
    categories: ["streaming", "tv-and-movies"],
    availableIn: ["IS"],
    sourceLinks: ["https://www.ruv.is"],
  },
  {
    name: "britbox",
    ownerCountry: "UK",
    categories: ["streaming", "tv-and-movies"],
    availableIn: ["CA", "AU", "DK", "FI", "NO", "SE"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/BritBox",
      "https://www.britbox.com/",
    ],
  },
  {
    name: "MUBI",
    ownerCountry: "UK",
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Mubi_(streaming_service)",
      "https://mubi.com",
    ],
  },
  {
    name: "Filmin",
    ownerCountry: "ES",
    availableIn: ["ES", "PT"],
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: ["https://www.filmin.es/"],
  },
  {
    name: "Strim",
    ownerCountry: "NO",
    headquarterIn: "NO",
    availableIn: ["NO"],
    comments: "Norwegian streaming service offering a wide range of TV channels, series, and movies, including both live TV and on-demand content.",
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: ["https://strim.no/"]
  },
  {
    name: "RTÉ Player",
    ownerCountry: "IE",
    headquarterIn: "IE",
    availableIn: ["IE"],
    comments: "Irish streaming service operated by RTÉ, offering live and on-demand access to Irish television programs, news, and entertainment content.",
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: ["https://en.wikipedia.org/wiki/RT%C3%89_Player", "https://www.rte.ie/player/"]
  },
  {
    name: "ARTE",
    ownerCountry: "FR",
    headquarterIn: "FR",
    availableIn: ["FR", "DE", "AT", "CH", "BE", "LU"],
    comments: "European public-service television network that promotes cultural programming and is available in multiple languages, focusing on arts, documentaries, and films.",
    categories: ["streaming", "tv-and-movies"],
    sourceLinks: ["https://www.arte.tv/en/", "https://en.wikipedia.org/wiki/Arte"]
  },
  {
    name: "CBC Gem",
    ownerCountry: "CA",
    availableIn: ["CA"],
    categories: ["streaming", "tv-and-movies"],
  },
  {
    name: "Crave",
    ownerCountry: "CA",
    availableIn: ["CA"],
    categories: ["streaming", "tv-and-movies"],
  },
  {
    name: "illico+",
    ownerCountry: "CA",
    availableIn: ["CA"],
    categories: ["streaming", "tv-and-movies"],
  },
];